export default class UserPicks{
    constructor(userEmail, partyId, picks){
       this.userEmail = userEmail;
       this.partyId = partyId;
       this.picks = picks;
    }
}